export enum TabScreens {
  Home = 'Home',
  Subscription='Subscription',
  Menu = 'Menu',
  Order = 'Order',
  Favorite = 'Favorite',
  Notification = 'Notification',
  Offer='Offer'
} 
export enum Routes{
  SubscriptionModify='/subscription-modify',
  WalletHistory='/transaction-history',
  Onboarding = '/pincode',
  SignIn = '/',
  OrderHistory = '/profile/orders',
  OrderHistoryEmpty = '/profile/orders-empty',
  EditProfile = '/profile/edit',
  VerifyYourEmail = '/verify-your-email',
  MyPromocodes = '/profile/promocodes',
  NewPassword = '/new-password',
  Filter = '/filter',
  SignUp = '/sign-up',
  SignUpAccountCreated = '/sign-up-account-created',
  ForgotPassword = '/forgot-password',
  OrderSuccessful = '/order-successful',
  Checkout = '/checkout',
  ForgotPasswordSentEmail = '/forgot-password-sent-email',
  Shop = '/shop',
  PromocodesEmpty = '/promocodes-empty',
  Reviews = '/reviews',
  Description = '/description',
  LeaveAReviews = '/leave-a-reviews',
  Product = '/product/:id',
  MyPromocodesEmpty = '/profile/promocodes-empty',
  TabNavigator = '/tab-navigator',
  Verification = '/verification',
  ConfirmationCode = '/confirmation-code',
  SendEmailOtp = '/send-email-otp',
  VerifyEmail = '/verify-email',
  SendPhoneOtp = '/send-phone-otp',
  VerifyPhone = '/verify-phone',
  EmailVerified = '/email-verified',
  PhoneVerified = '/phone-verified',
  MenuList = '/menu-list',
  Search = '/search',
  Wallet = '/wallet',
  Promocodes = '/store-locator',
  ShippingAPaymentInfo = '/shipping-a-payment-info',
  OrderFailed = '/order-failed',
  TrackYourOrder = '/track-your-order',
  LeaveAReview = '/leave-a-review',
  FAQ = '/faq',
  Dish = '/dish/:id',
  CheckoutPaymentMethod = '/checkout-payment-method',
  CheckoutShippingDetails = '/checkout-shipping-details',
  PaymentMethod = '/payment-method',
  AddANewAddress = '/add-a-new-address',
  AddANewCard = '/add-a-new-card',
  VerifyYourPhoneNumber = '/verify-your-phone-number',
  MyAddress = '/address',
  AddressAdd='/add-your-address',  
  ClientNotification='/notification',
  ClientNotificationDetails='/notification-message',
  CustomerCare='/customer-care',
  OrderSubscription='/orderSubscription',
  SubsCriptionOrder='/subscription-Order',
  CouponList='/coupon-list',
  CouponSummary='/coupon-summary',
  SubscriptionOrderCheck='/your-order',
  OrderItemCoupon='/order-item',
  SelectMyAddress='/select-Address',
  ThankYouPage='/thank-you',
  NewUsereAddAddress='/new-address',
  SelectAddressFromHome='/selected-address'
}
